const cache = new Map<string, Promise<HTMLImageElement>>();

export function loadImage(src: string): Promise<HTMLImageElement> {
  let promise = cache.get(src);
  if (!promise) {
    promise = new Promise((resolve, reject) => {
      const img = new Image();
      img.onload = () => resolve(img);
      img.onerror = reject;
      img.src = src;
    });
    cache.set(src, promise);
  }
  return promise;
}

/**
 * Draws the image as a blocks×blocks mosaic (or sharp when blocks is null).
 * Downscales in halving steps so each block is a fair average, not a random pixel.
 */
export function drawPixelated(canvas: HTMLCanvasElement, img: HTMLImageElement, blocks: number | null): void {
  const size = canvas.width;
  const ctx = canvas.getContext('2d')!;
  ctx.clearRect(0, 0, size, size);
  if (blocks === null) {
    ctx.imageSmoothingEnabled = true;
    ctx.imageSmoothingQuality = 'high';
    ctx.drawImage(img, 0, 0, size, size);
    return;
  }
  let source: CanvasImageSource = img;
  let current = img.naturalWidth;
  while (current / 2 > blocks) {
    current = Math.max(blocks, Math.floor(current / 2));
    source = scaled(source, current);
  }
  const small = scaled(source, blocks);
  ctx.imageSmoothingEnabled = false;
  ctx.drawImage(small, 0, 0, size, size);
}

function scaled(source: CanvasImageSource, side: number): HTMLCanvasElement {
  const c = document.createElement('canvas');
  c.width = c.height = side;
  const ctx = c.getContext('2d')!;
  ctx.imageSmoothingEnabled = true;
  ctx.imageSmoothingQuality = 'high';
  ctx.drawImage(source, 0, 0, side, side);
  return c;
}
